
/* injects from baggage-loader */

'use strict';

import BalloonsDirective from './balloons.directive';

const BalloonsModule = angular.module('balloons-module', []);

BalloonsModule
	.directive('balloons', BalloonsDirective);

export default BalloonsModule;



// WEBPACK FOOTER //
// ./src/app/components/balloons/balloons.module.js